import * as Styled from './styled';

const Spinner: React.FC<{ size?: number }> = ({ size, ...props }) => {
  return <Styled.Spinner size={size} {...props} />;
};

export default Spinner;
